<template>
    <div class="funding-details-link">
        <ob1-liens-icone
            mini
            is-button
            icon="icon-info-alt"
            :title="text"
            @click="$emit('fundingDetailsClick', seoId)"
        />
    </div>
</template>

<script>

export default {
    props: {
        seoId: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        }
    }
}
</script>
